import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Komponenter
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import Interior from './pages/Interior';
import SolfilmPage from './pages/SolfilmPage';
import DekorationPage from './pages/DekorationPage';
import LogoDesign from './pages/LogoDesign';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-slate-50 text-gray-900 font-sans selection:bg-brand-green-light selection:text-brand-dark">
        {/* Sørg for at siden altid ruller til toppen ved sideskift */}
        <ScrollToTop />
        
        {/* Global Header */}
        <Header />
        
        {/* Hovedindhold */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Dekoration undersider */}
            <Route path="/dekoration" element={<DekorationPage forcedType="bil" />} />
            <Route path="/dekoration/lastbil" element={<DekorationPage forcedType="lastbil" />} />
            <Route path="/dekoration/bil" element={<DekorationPage forcedType="bil" />} />
            <Route path="/dekoration/vaeg" element={<DekorationPage forcedType="vaeg" />} />

            {/* Solfilm undersider */}
            <Route path="/solfilm" element={<SolfilmPage forcedType="bil" />} />
            <Route path="/solfilm/bil" element={<SolfilmPage forcedType="bil" />} />
            <Route path="/solfilm/maskin" element={<SolfilmPage forcedType="maskin" />} />
            <Route path="/solfilm/hus" element={<SolfilmPage forcedType="hus" />} />
            <Route path="/maskin-bilsolfilm" element={<SolfilmPage forcedType="bil" />} />
            
            {/* Øvrige sider */}
            <Route path="/interioerfolie" element={<Interior />} />
            <Route path="/logodesign" element={<LogoDesign />} />
            <Route path="/kontakt" element={<Contact />} />
            
            {/* Fejlsider */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        
        {/* Global Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
